import { LeftOutlined } from '@ant-design/icons'
import React from 'react'

import { StyledPrevStep, StyledPrevButton } from '../components'

type Props = {
  prevStep: () => void
}

export const NuevaSolicitud: React.FC<Props> = ({ prevStep }) => (
  <StyledPrevStep>
    <StyledPrevButton onClick={prevStep}>
      <LeftOutlined style={{ color: 'black' }} />
      Nueva Solicitud
    </StyledPrevButton>
  </StyledPrevStep>
)
